module.exports = {"name":"madLibs","audiences":["newAndNoTeams"],"experimentAllocation":0,"defaultWeight":1,"experimentVersion":"v1","autoTrack":true,"defaults":{"enabled":false},"audienceSettings":{"startDate":"2018-07-30"},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/madLibs.json
// module id = tMYW
// module chunks = 1